function l(r){let e=!1,t;return()=>(e||(t=r(),e=!0),t)}export{l as a};
